import { useCallback } from "react";
import { useLoader } from './useLoader';
import {
    onError,
    onSuccess,
} from '../components/shared/messages';

const useCallbackWithLoader = () => {
    const loader = useLoader();

    const callbackWithLoader = useCallback(async (callback, {
        showSuccessMessage = false,
        onErrorResult = false,
    } = {}) => {
        try {
            loader(true);
            let resultOrPromise = callback();
            if (resultOrPromise instanceof Promise) {
                resultOrPromise = await resultOrPromise;
            }
            if (showSuccessMessage) {
                onSuccess();
            }
            return resultOrPromise;
        } catch(error) {
            onError(error);
            console.error(error);
            return onErrorResult;
        } finally {
            loader(false);
        }
    }, [loader]);

    return callbackWithLoader;
};

export default useCallbackWithLoader;
